<div class="switcher" @click="toggle" :class="{ on, disabled }"><div class="line"></div><div class="head"></div></div>